import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const ArrowLeft = t0 => {
  const $ = _c(9);
  let props;
  let style;
  if ($[0] !== t0) {
    ({
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = style;
  } else {
    props = $[1];
    style = $[2];
  }
  let t1;
  if ($[3] !== style) {
    t1 = {
      transform: "rotate(360deg)",
      ...style
    };
    $[3] = style;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M10 6L2 16l8 10M2 16h28" /></g>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" focusable="false" style={t1} preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32" {...props}>{t2}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
ArrowLeft.propTypes = {
  style: PropTypes.objectOf(PropTypes.object)
};
export default ArrowLeft;